<template>

    <div id="webhook-logs">

        <div class="mb-4">
            <h1 class="text-2xl font-medium text-gray-900 capitalize">Logs</h1>
        </div>

        <div class="filter-bar" v-if="form">
            <ul class="grid-cols-3">
                <li>
                    <button @click="navigateSection(false)" :class="{ 'active': form.type === false }">
                        All
                    </button>
                </li>
                <li>
                    <button @click="navigateSection('successful')" :class="{ 'active': form.type === 'successful' }">
                        Successful
                    </button>
                </li>
                <li>
                    <button @click="navigateSection('failed')" :class="{ 'active': form.type === 'failed' }">
                        Failed
                    </button>
                </li>
            </ul>
            <div class="filters grid-cols-6">
                <div class="filter-control col-span-6 xl:col-span-2">

                </div>
            </div>

        </div>

        <div class="split-index-table" v-if="loaded">
            <div>
                <div class="index-table" v-if="form.index_data.data.length > 0" >
                    <div>
                        <div>
                            <table>
                                <thead>
                                    <tr class="flex">
                                        <th scope="col" class="w-1/2 xl:w-5/12 text-left tracking-wider">Request Logs</th>
                                        <th scope="col" class="w-1/2 xl:w-3/12 text-center tracking-wider">Status</th>
                                        <th scope="col" class="hidden xl:table-cell xl:w-4/12 text-left tracking-wider">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody class="flex flex-col justify-between overflow-y-scroll w-full max-h-96 xl:max-h-120">
                                    <tr class="flex px-2 colored-row cursor-pointer" :class="{ 'selected-row': form.selected.uuid === log.uuid }" v-for="(log, index) in form.index_data.data" @click.prevent="viewLog(index)">
                                        <td class="w-1/2 xl:w-5/12 justify-start">
                                            <span class="mr-2 status-box status-open">POST</span>
                                            <span class="font-medium">{{ ellipsis(log.url, 20) }}</span>
                                            <br>
                                            <span class="text-xs text-gray-500">{{ log.uuid }}</span>
                                        </td>
                                        <td class="w-1/2 xl:w-3/12 justify-center text-center">
                                            <span :class="`status-box ${statusBox(log.status)}`">
                                                {{ log.status }} {{ log.status_text }}
                                            </span><br>
                                            &nbsp;
                                        </td>
                                        <td class="hidden xl:table-cell xl:w-4/12 justify-end text-right">
                                            <span class="text-xs">{{ formatDate(log.created_at) }}</span><br>
                                            <span class="text-xs text-gray-500">Request made {{ log.created_human_readable }}</span>
                                        </td>
                                    </tr>
                                    <tr class="py-6 text-xs font-medium">
                                        <infinite-loading @infinite="infiniteHandler">
                                            <div slot="spinner">Loading...</div>
                                            <div slot="no-more">No more Logs</div>
                                        </infinite-loading>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="no-results panel" v-else>
                    <div class="p-10">
                        <div class="text-gray-200 my-6">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z" />
                            </svg>
                        </div>

                        <h2 class="text-gray-600 font-medium text-2xl text-center">No Logs Available</h2>

                        <p class="text-center mt-4 text-sm text-gray-500">
                            We could not find any logs.
                        </p>
                    </div>
                </div>
                <div class="index-table-preview max-h-96 xl:max-h-132" v-if="form.index_data.data.length > 0">
                    <div v-if="form.selected">
                        <h2 class="flex items-center font-medium text-2xl pb-2">
                            <span :class="`status-box mr-2 status-box status-open`">POST</span>
                            {{ form.selected.url }}
                        </h2>

                        <table class="text-sm mb-5 w-full">
                            <tbody>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Request ID</td>
                                <td class="w-4/6">{{ form.selected.uuid }}</td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Status</td>
                                <td class="w-4/6">
                                    <a :href="`https://httpstatuses.com/${form.selected.status}`" class="flex text-indigo-500 hover:text-indigo-400" target="_blank">
                                        <span :class="`status-box ${statusBox(form.selected.status)}`">
                                            {{ form.selected.status }} {{ form.selected.status_text }}
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Account</td>
                                <td class="w-4/6">
                                <span>{{ form.selected.account_name }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="w-2/6 text-gray-400 py-1">Date</td>
                                <td class="w-4/6">{{ form.selected.created_at }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <h3 class="font-medium mb-1 ml-4 text-base">Request Body</h3>

                        <div class="text-3xl">
                            <pre class="p-0 m-0"><code class="language-json" :id="`request-block-${form.selected.uuid}`">{{ form.selected.request ? form.selected.request : 'no request body' }}</code></pre>
                        </div>

                        <h3 class="font-medium mb-1 ml-4 text-base">Response Body</h3>

                        <div class="text-3xl">
                            <pre class="p-0 m-0"><code class="language-json" :id="`response-block-${form.selected.uuid}`">{{ form.selected.response ? form.selected.response : 'no request body' }}</code></pre>
                        </div>

                    </div>
                    <div class="loading" v-else>
                        <Loading :message="false" :show_long_loading="false"></Loading>
                    </div>
                </div>
            </div>
        </div>
        <Loading message="Loading Logs" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {WebhookLogs} from "../../app/Log/WebhookLogs";
import Prism from 'prismjs'
import 'prismjs/components/prism-json'
import InfiniteLoading from "vue-infinite-loading";
import {FormattingMixin, HttpStatusMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "WebhookLogs",
    mixins: [PermissionMixin, FormattingMixin, HttpStatusMixin],
    data() {
        return {
            form: null,
            current_user: null,
            loaded: false,
        }
    },
    components: {
        Loading,
        InfiniteLoading
    },
    methods: {
        navigateSection(section) {
            let vm = this;

            return new Promise(resolve => {
                vm.loaded = false;
                vm.form.type = section;
                vm.form.page = 1;

                vm.form.getLogs().then(result => {

                    vm.loaded = true;

                    resolve(result);
                }).then(result => {
                    vm.viewLog(0);
                });
            });
        },
        viewLog(index) {
            let vm = this;

            vm.form.selected = false;

            setTimeout(function () {
                vm.form.selectLog(index).then(response => {
                    Prism.highlightAll();
                });
            }, 200);

        },
        infiniteHandler($state) {
            let vm = this;

            vm.form.page += 1;

            if (vm.form.indexHasMoreResults()) {
                this.form.getLogs(true).then(response => {
                    $state.loaded();

                    Prism.highlightAll();
                });
            } else {
                $state.loaded();
                $state.complete();
            }
        },
    },
    mounted() {
        let vm = this;

        vm.type = vm.$route.params.type ?? false;

        new Promise(resolve => {
            vm.form = new WebhookLogs();

            vm.form.getLogs().then(response => {
                resolve(true);
            }).catch(error => vm.handleError(error));

        }).then(result => {
            vm.loaded = result;

            vm.viewLog(0);
        })
    }
}
</script>


